import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Chave no sessionStorage para passar message/email à página /auth após definir senha (parceiro/vendedor). */
export const DEFINIR_SENHA_REDIRECT_KEY = "sun7_definir_senha_redirect"

/** Remove sessão do Supabase do localStorage para forçar estado "signed out" (evita 403 do signOut). */
export function clearSupabaseSessionFromStorage(): void {
  if (typeof localStorage === "undefined") return
  const keys: string[] = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key?.startsWith("sb-")) keys.push(key)
  }
  keys.forEach((k) => localStorage.removeItem(k))
}
